const acceslevel = {
  accesslevel: "Niveau d'accès",
  access_level: "Niveau d'accès",
  search_accesslevel: "Rechercher un niveau d'accès",
  add_accesslevel: "Nouveau niveau d'accès",
  accesslevel_manager: 'Gérer',
  doors: 'Portes',
  schedules: 'Horaires',
  can_not_delete: "Le niveau d'accès est protégé. Il ne peut pas être supprimé",
  form: {
    door_schedule: 'Horaire de porte',
    status: 'Statut',
    active: 'Actif',
    inactive: 'Inactif',
  },
  table: {
    state: 'ÉTAT',
    accesslevel: "NIVEAU D'ACCÈS",
    schedules: 'PROGRAMME',
  },
  manager: {
    add_users: 'Ajouter des utilisateurs',
    search_users: 'Rechercher des utilisateurs',
    user_count: "Nombre d'utilisateurs",
    assign_accesslevel: "Attribuer un niveau d'accès",
    access_remove_success: "Niveau d'accès désassigné avec succès",
    access_remove_error: "Erreur lors de la désassignation du niveau d'accès",
    access_add_success: "Niveau d'accès attribué avec succès",
    access_add_error: "Erreur lors de l'attribution du niveau d'accès",
    remove_selected_btn: 'Désassigner à ({{count}}) sélectionné(s)',
    remove_selected_msg:
      'Êtes-vous sûr de vouloir désassigner {{accessLevelLabel}} des utilisateurs suivants ?',
    add_selected_btn: 'Attribuer à ({{count}}) sélectionné(s)',
    add_selected_msg:
      'Êtes-vous sûr de vouloir attribuer {{accessLevelLabel}} aux utilisateurs suivants ?',
    replace_selected_btn: 'Remplacer à ({{count}}) sélectionné(s)',
    replace_success: "Remplacement du niveau d'accès réussi",
    replace_error: "Erreur lors du remplacement du niveau d'accès",
    replace_alevel_msg:
      'Êtes-vous sûr de vouloir remplacer {{accessLevelLabel}} par {{newAccessLevelLabel}} pour les utilisateurs suivants ?',
    count_users_selected: '{{count}} utilisateurs sélectionnés',
    users_with_errors:
      "Le niveau d'accès ne peut pas être attribué aux utilisateurs suivants :",
    alert: 'Alerte',
  },
};

export default acceslevel;
